export default __webpack_public_path__ + "static/media/hiclipart_21.87bb3ec6.png";